import { Box, ListItem, Typography, Divider, Chip } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomToolbar from "./CustomToolbar";
import Scrollbar from "../../../reusable-components/scrollbar";

export default function MobilePortfolioList() {
  const { portfolios } = useSelector((state) => state.transitions.data);
  const navigate = useNavigate();
  return <>
    <CustomToolbar />
    <Scrollbar sx={{borderRadius: 1, my: 1, maxHeight: 'calc(100vh - 250px)', overflowY: 'auto'}} style={{backgroundColor: 'white'}}>
      {portfolios?.map((portfolio) => (
      <Box key={portfolio.id}>
        <ListItem
          alignItems="flex-start"
          sx={{ flexDirection: 'column', alignItems: 'stretch', py: 1 }}
          onClick={() => navigate(`/dashboard/transitions/initial-due-diligence/${portfolio.id}`)}
        >
          <Typography variant="subtitle1" color="info.main" fontWeight="bold">{portfolio.portfolioName}</Typography>
          <Typography variant="body2" color="text.secondary">
            Company: {portfolio.companyName}
          </Typography>
          <Box sx={{display: 'flex'}}>
            <Typography variant="body2" color="text.secondary">
              Status: 
            </Typography>
            <Chip
              size="small"
              label={portfolio.transitionStatus}
              color="secondary"
              variant="outlined"
              sx={{ ml: 0.5, borderRadius: 0.5 }}
            />
          </Box>
          <Typography variant="body2" color="text.secondary">
            Facilities: {portfolio.facilities?.length || 0}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Date Added: {new Date(portfolio.dateAdded).toLocaleDateString('en-US', {
              year: 'numeric', month: '2-digit', day: '2-digit'
            })}
          </Typography>
        </ListItem>
        <Divider sx={{width: '90%', margin: 'auto'}}/>
      </Box>))}
    </Scrollbar>
    </>
}